import type { FC } from 'react'

import type { ResApplicantDetail } from '@/lib/queries/business/v1/types'

import { ApplicantSettings } from './applicant-settings'

export const ApplicantConfigs: FC<{
  applicant: ResApplicantDetail
  onInvalidate: () => Promise<void>
}> = ({ applicant, onInvalidate }) => {
  return (
    <div className="flex gap-4">
      <ApplicantSettings applicant={applicant} onInvalidate={onInvalidate} />
    </div>
  )
}
